export const SUPPORTED_CURRENCIES = ['CAD', 'USD', 'EUR', 'GBP', 'AUD', 'JPY']

// CAD -> X defaults derived from worker fallback X->CAD rates
export const DEFAULT_CAD_TO_RATES = {
  CAD: 1,
  USD: 1 / 1.35,
  EUR: 1 / 1.5,
  GBP: 1 / 1.75,
  AUD: 1 / 0.9,
  JPY: 1 / 0.009,
}

export const CURRENCY_STORAGE_KEY = 'lilycove_display_currency'
